export const translations = {
	'Eventlog configuration': {
		en: 'Eventlog configuration',
		no: 'Hendelselogg konfigurasjon',
	},
	'Frequency analysis': {
		en: 'Frequency analysis',
		no: 'Frekvensanalyse',
	},
	'Reason reduction indication': {
		en: 'Reason reduction indication',
		no: 'Indikasjon på årsaksreduksjon',
	},
	'Reset pending': {
		en: 'Reset indication',
		no: 'Indikasjon på tilbakestilling',
	},
	'Summary reasons': {
		en: 'Summary reasons',
		no: 'Sammendragsårsaker',
	},
	'Ignore event text on comparison': {
		en: 'Ignore event text on comparison',
		no: 'Ignorer hendelsestekst ved sammenligning',
	},
	'Suppression count': {
		en: 'Suppression count',
		no: 'Antall undertrykkelser',
	},
	'Expiry time (h)': {
		en: 'Expiry time (h)',
		no: 'Utløpstid (t)',
	},
	'Event mapping': {
		en: 'Event mapping',
		no: 'Hendelseskartlegging',
	},
	'Log types': {
		en: 'Log types',
		no: 'Loggtyper',
	},
	'Log filter': {
		en: 'Log filter',
		no: 'Loggfilter',
	},
	'Monitor error if log type is not found': {
		en: 'Monitor error if log type is not found',
		no: 'Monitoren feiler hvis loggtype ikke blir funnet',
	},
	'Audit Success': {
		en: 'Audit success',
		no: 'Revisjon suksess',
	},
	'Audit Failure': {
		en: 'Audit failure',
		no: 'Revisjon feil',
	},
	'Monitor config': {
		en: 'Monitor configuration',
		no: 'monitorkonfigurasjon',
	},
	'Exclude filter': {
		en: 'Exclude filter',
		no: 'Ekskluder filter',
	},
	'Include filter': {
		en: 'Include filter',
		no: 'Inkluder filter',
	},
	'Event ID': {
		en: 'Event ID',
		no: 'Hendelses ID',
	},
	'Label': {
		en: 'Label',
		no: 'Etikett',
	},
	'Events': {
		en: 'Events',
		no: 'Hendelser',
	},
	'Event level': {
		en: 'Event level',
		no: 'Hendelsesnivå',
	},
	'Add mapping': {
		en: 'Add mapping',
		no: 'Legg til kartlegging',
	},
	'Add filter': {
		en: 'Add filter',
		no: 'Legg til filter',
	},
	'Test parameters: Log types: {0} | Event level: {1} |  Source: {2} | Event ID: {3} | Message: {4}. We only show the first 15 events that match the filter.':
		{
			en: 'Test parameters: Source: {0} | Event ID: {1} | Message: {2}. We only show the first 15 events that match the filter.',
			no: 'Testparametere: Kilde {0} | Hendelses-ID: {1} | Melding: {2}. Vi viser bare de første 15 hendelsene som samsvarer med filteret.',
		},
	'Click + button or here to create an event mapping': {
		en: 'Click + button or here to create an event mapping',
		no: 'Klikk på +-knappen eller her for å opprette en hendelseskobling',
	},
	'Include ({0})': {
		en: 'Include ({0})',
		no: 'Inkluder ({0})',
	},
	'Exclude ({0})': {
		en: 'Exclude ({0})',
		no: 'Ekskluder ({0})',
	},
	'Information (internal, not used in filter)': {
		en: 'Information (internal, not used in filter)',
		no: 'Informasjon (intern, brukes ikke i filteret)',
	},
	'Test all filters': {
		en: 'Test all filters',
		no: 'Test alle filtre',
	},
	'Log': {
		en: 'Log',
		no: 'Logg',
	},
	'Test result': {
		en: 'Test result',
		no: 'Testresultat',
	},
	'Max event age': {
		en: 'Max event age',
		no: 'Maksimal hendelsesalder',
	},
	'Please set at least one log type': {
		en: 'Please set at least one log type',
		no: 'Velg minst én loggtype.',
	},
	'Include ({0})': {},
	'Exclude ({0})': {},
	'Information (internal, not used in filter)': {},
	'Test all filters': {},
	'General configuration complete. Click here to go to Events tab for further configuration.': {
		no: 'Den generelle konfigurasjonen er fullført. Klikk her for å gå til fanen Hendelser og fortsette konfigureringen.',
	},
	'Assets in asset group:': {},
	'Event schedule': {},
	'Default schedule tooltip': {
		en: 'The event schedule defines when Windows events are evaluated and can raise alerts; events logged outside the schedule is not processed.',
		no: 'Hendelsesplanen angir når Windows-hendelser evalueres og kan utløse varsler. Hendelser som logges utenfor planen, behandles ikke',
	},
	'Event reason': {
		en: 'Event reason',
		no: 'Hendelseårsak',
	},
	'Invalid regular expression': {
		no: 'Ugyldig regulært uttrykk',
	},
	'Filters contain an invalid regular expression': {
		no: 'Filtrene inneholder et ugyldig regulært uttrykk',
	},
};
